import React from 'react';
import { Link } from 'react-router-dom';

const GingeryShotsPrivacyPolicy = () => {
  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6', maxWidth: '800px', margin: 'auto' }}>
      <h1 style={{ textAlign: 'center' }}>Privacy Policy for GingeryShots</h1>
      <p style={{ fontStyle: 'italic', textAlign: 'center' }}>Last Updated: [28/10/2025]</p>

      <p>Welcome to GingeryShots! We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we handle information when you use our app.</p>

      <p>By accessing or using GingeryShots, you agree to this Privacy Policy. If you disagree with any part of this policy, please do not use the app or our services.</p>

      <h2>1. Information We Collect</h2>
      <p>GingeryShots does not collect any personal information from its users. We do not require you to submit personal data, nor do we automatically collect usage data, IP addresses, or device information. Our app is designed with privacy in mind and avoids unnecessary data collection.</p>

      <h2>2. How We Use Your Information</h2>
      <p>As we do not collect personal information, we do not use or process any data related to you. GingeryShots functions entirely without user tracking or profiling.</p>
      
      <p><strong>Please note:</strong> GingeryShots provides general wellness and nutritional information only. It is not medical advice, and the content should not be used to diagnose, treat, or prevent any health condition. Always consult a qualified healthcare professional before making changes to your diet or lifestyle, particularly if you have any medical conditions, allergies, or concerns.</p>

      <h2>3. Sharing Your Information</h2>
      <p>We do not share, sell, or rent any information, as no personal data is collected from you. There is no data shared with third parties.</p>

      <h2>4. Security of Your Information</h2>
      <p>While GingeryShots does not store personal data, we take security seriously. We maintain measures to ensure that the app remains safe, secure, and protected from external threats.</p>

      <h2>5. Your Rights</h2>
      <p>Since GingeryShots does not collect or store personal information, there are no specific rights related to data access, modification, or deletion. You are free to use the app without providing any personal details.</p>

      <h2>6. Children's Privacy</h2>
      <p>GingeryShots is not intended for children under the age of 13. We do not knowingly collect information from children. If we become aware that information from a child under 13 has been collected unintentionally, it will be promptly deleted.</p>

      <h2>7. Changes to This Privacy Policy</h2>
      <p>We may update this Privacy Policy from time to time. Any changes will be posted directly within this section of the app. We encourage you to review this policy periodically to stay informed. Continued use of GingeryShots after updates signifies your acceptance of any changes.</p>

      <h2>8. Contact Us</h2>
      <p>If you have any questions or concerns regarding this Privacy Policy, please contact us through the app's available support options.</p>
      <Link to="/support">Support</Link>

      <hr style={{ margin: '30px 0', border: 'none', borderTop: '1px solid #ccc' }} />
      
      <h2>Disclaimer</h2>
      <p>GingeryShots is intended for general wellness and informational purposes only. It does not provide medical advice or professional health guidance. Always consult your GP or healthcare professional before relying on information from this app for medical decisions.</p>
      
      <p style={{ textAlign: 'center', fontWeight: 'bold', marginTop: '20px' }}>© 2025 GingeryShots. All rights reserved.</p>
    </div>
  );
};

export default GingeryShotsPrivacyPolicy;
